import Pic from '../components/Pic'

export default (Vue) => {
    Vue.component("Pic", Pic)
}


// WEBPACK FOOTER //
// ./src/util/components.js